var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSnippetlarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.22 5.6c0-1.13.91-2.05 2.05-2.05h1.07V1.79H4.27c-2.1 0-3.81 1.7-3.81 3.8v12.14c0 2.1 1.7 3.82 3.8 3.82h5.11a2.93 2.93 0 0 0 2.9 2.45h7.46a2.93 2.93 0 0 0 2.94-2.93V10.93A2.93 2.93 0 0 0 19.73 8h-7.46a2.93 2.93 0 0 0-2.94 2.93v8.86H4.27a2.05 2.05 0 0 1-2.05-2.06V5.6Zm11.12-2.05h1.06c1.14 0 2.06.92 2.06 2.05V8h1.76V5.6c0-2.1-1.71-3.81-3.82-3.81h-1.06v1.76Zm-1.07 6.21h7.46c.65 0 1.18.53 1.18 1.17v10.14c0 .64-.53 1.17-1.18 1.17h-7.46c-.65 0-1.18-.53-1.18-1.17V10.93c0-.64.53-1.17 1.18-1.17Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1.76H6.67a.9.9 0 0 0 0 1.81H12a.9.9 0 0 0 0-1.81ZM6.67 0a2.67 2.67 0 0 0 0 5.33H12A2.67 2.67 0 1 0 12 0H6.67ZM13.31 16c0-.44.36-.8.8-.8h4a.8.8 0 1 1 0 1.6h-4a.8.8 0 0 1-.8-.8ZM13.31 13.33c0-.44.36-.8.8-.8h4a.8.8 0 0 1 0 1.6h-4a.8.8 0 0 1-.8-.8ZM13.31 18.67c0-.45.36-.8.8-.8h1.34a.8.8 0 1 1 0 1.6H14.1a.8.8 0 0 1-.8-.8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnippetlarge);
export default __webpack_public_path__ + "static/media/snippet.large.436054356d4c9219455b32b015054603.svg";
export { ForwardRef as ReactComponent };